import { useTranslation } from "react-i18next";
import { FormSectionComponent } from "./FormSectionComponent";
import { Typography } from "@mui/material";
import { OrderType } from "../../../../orderAPI";
import { TesRow } from "./components/TesRow";
import { useFormContext } from "react-hook-form";
import { FormKeys, WorkOfferType } from "../helpers";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../../app/hooks";
import { selectOrderRowById } from "../../../../orderRowsDetailedSlice";

const ORDER_TYPE_TO_TRANSLATION_KEY = {
  [OrderType.FixedTerm]: "fixedTermOrderLabel",
  [OrderType.Continuous]: "continuousOrderLabel",
  [OrderType.Short]: "shortOrderLabel",
};
interface Props {
  type: WorkOfferType;
}

export const TermsOfEmployment = ({ type }: Props) => {
  const { t } = useTranslation();

  const { bundleId } = useParams();
  const order = useAppSelector((state) => selectOrderRowById(state, bundleId!));

  const { getValues } = useFormContext();

  // This doesn't exist for continuous orders
  const orderReason = getValues(FormKeys.ReasonForTemporaryEmployment);

  const orderTypeTranslationKey = ORDER_TYPE_TO_TRANSLATION_KEY[order?.type];
  const orderTypeLocalized = t(`order:${orderTypeTranslationKey}`);
  const orderReasonLocalized = t(`order:${orderReason}`);
  const typeAndReason = `${orderTypeLocalized} (${orderReasonLocalized})`;

  const typeTitle = !!orderReason ? t("order:typeAndBasis") : t("order:types");
  const typeContent = !!orderReason ? typeAndReason : orderTypeLocalized;

  const rows = [
    {
      title: t("common:TES"),
      component: <TesRow type={type} />,
    },
    {
      title: typeTitle,
      component: <Typography>{typeContent}</Typography>,
    },
  ];

  return (
    <FormSectionComponent title={t("order:termsOfEmployment")} rows={rows} />
  );
};
